module.exports = __webpack_public_path__ + "img/manageit-digital_logoMobile.f15bfa66.png";